import React from 'react';
import { Helmet } from 'react-helmet-async';

const SEO = ({ title, description, keywords, image, url, type = 'website', lang = 'id', children }) => {
  const siteTitle = 'aurora.code - Jasa Pembuatan Website & Solusi Digital Indonesia';
  const siteName = 'aurora.code';
  const metaDescription = description || 'aurora.code - Jasa Pembuatan Website Profesional & Solusi Digital | Spesialis Company Profile, E-Commerce, dan Sistem Informasi Custom. Kami melayani pembuatan website murah, modern, SEO-friendly, dan cepat untuk bisnis di Tulungagung, Kediri, Blitar, Jawa Timur, hingga seluruh Indonesia dan Internasional. Professional Web Development Services in Indonesia.';
  
  const defaultKeywords = 'jasa pembuatan website, jasa buat web, web developer indonesia, jasa bikin website murah, bikin web company profile, buat toko online, jasa website custom, jasa pembuatan sistem informasi, agensi web terpercaya, jasa seo website, web design tulungagung, pembuat web cepat, freelancer web developer, perusahaan pembuat website, software house indonesia, aplikasi custom, website dinamis, konsultan IT, digital agency jawa timur, web development company indonesia, professional web developer, custom website development services, responsive web design agency, ecommerce website developer, hire web developer indonesia, affordable web development company, best web design services, IT consultant indonesia, web application development, custom software development, SEO friendly website development, high performance website, aurora code, auroracode seo';
  const metaKeywords = keywords ? `${keywords}, ${defaultKeywords}` : defaultKeywords;
  
  const metaTitle = title ? `${title} | aurora.code` : siteTitle;
  const metaImage = image || 'https://auroracode.tech/logo.webp';
  const metaUrl = url || 'https://auroracode.tech/';
  const canonical = url || 'https://auroracode.tech/';

  const organizationData = {
    "@context": "https://schema.org",
    "@type": "Organization",
    "name": "aurora.code",
    "url": "https://auroracode.tech/",
    "logo": "https://auroracode.tech/logo.webp",
    "description": metaDescription,
    "sameAs": [
      "https://github.com/auroracode-id"
    ],
    "contactPoint": {
      "@type": "ContactPoint",
      "telephone": "+6285154043951",
      "contactType": "customer service",
      "areaServed": ["ID", "Worldwide"],
      "availableLanguage": ["Indonesian", "English"]
    }
  };

  const localBusinessData = {
    "@context": "https://schema.org",
    "@type": "ProfessionalService",
    "name": "aurora.code Web Development",
    "image": "https://auroracode.tech/logo.webp",
    "@id": "https://auroracode.tech/",
    "url": "https://auroracode.tech/",
    "telephone": "+6285154043951",
    "priceRange": "Rp",
    "address": {
      "@type": "PostalAddress",
      "addressLocality": "Tulungagung",
      "addressRegion": "Jawa Timur",
      "postalCode": "66212",
      "addressCountry": "ID"
    },
    "geo": {
      "@type": "GeoCoordinates",
      "latitude": -8.0667,
      "longitude": 111.9
    },
    "openingHoursSpecification": {
      "@type": "OpeningHoursSpecification",
      "dayOfWeek": [
        "Monday",
        "Tuesday",
        "Wednesday",
        "Thursday",
        "Friday",
        "Saturday",
        "Sunday"
      ],
      "opens": "00:00",
      "closes": "23:59"
    },
    "sameAs": [
      "https://github.com/auroracode-id"
    ]
  };

  return (
    <Helmet>
      {/* Basic Meta Tags */}
      <html lang={lang} />
      <title>{metaTitle}</title>
      <meta name="description" content={metaDescription} />
      <meta name="keywords" content={metaKeywords} />
      <meta name="author" content="aurora.code" />
      <meta name="publisher" content="aurora.code" />
      <meta name="robots" content="index, follow, max-image-preview:large, max-snippet:-1, max-video-preview:-1" />
      <link rel="canonical" href={canonical} />
      
      {/* Open Graph / Facebook */}
      <meta property="og:site_name" content={siteName} />
      <meta property="og:type" content={type} />
      <meta property="og:url" content={metaUrl} />
      <meta property="og:title" content={metaTitle} />
      <meta property="og:description" content={metaDescription} />
      <meta property="og:image" content={metaImage} />
      <meta property="og:image:alt" content={metaTitle} />
      <meta property="og:image:width" content="1200" />
      <meta property="og:image:height" content="630" />
      <meta property="og:locale" content="id_ID" />
      <meta property="og:locale:alternate" content="en_US" />

      {/* Twitter */}
      <meta name="twitter:card" content="summary_large_image" />
      <meta name="twitter:site" content="@auroracode" />
      <meta name="twitter:creator" content="@auroracode" />
      <meta name="twitter:url" content={metaUrl} />
      <meta name="twitter:title" content={metaTitle} />
      <meta name="twitter:description" content={metaDescription} />
      <meta name="twitter:image" content={metaImage} />
      <meta name="twitter:image:alt" content={metaTitle} />

      {/* Language / Alternate */}
      <link rel="alternate" hrefLang="id" href="https://auroracode.tech/" />
      <link rel="alternate" hrefLang="en" href="https://auroracode.tech/" />
      <link rel="alternate" hrefLang="x-default" href="https://auroracode.tech/" />

      {/* Additional Meta Tags */}
      <meta name="format-detection" content="telephone=no" />
      <meta name="theme-color" content="#000000" />
      <meta name="apple-mobile-web-app-capable" content="yes" />
      <meta name="apple-mobile-web-app-status-bar-style" content="black" />
      <meta name="mobile-web-app-capable" content="yes" />

      {/* Structured Data */}
      <script type="application/ld+json">
        {JSON.stringify(organizationData)}
      </script>
      <script type="application/ld+json">
        {JSON.stringify(localBusinessData)}
      </script>
      
      {/* Additional custom elements */}
      {children}
    </Helmet>
  );
};

export default SEO;
